import React from 'react'
import { Skeleton, Box } from '@mui/material';
const SkeletonLoader = () => {
  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
        {/* Sidebar Skeleton */}
        <Box sx={{ width: 250, p: 2, bgcolor: 'grey.200' }}>
          <Skeleton variant="rectangular" width="100%" height={50} sx={{ mb: 2 }} />
          <Skeleton variant="text" height={40} sx={{ mb: 1 }} />
          <Skeleton variant="text" height={40} sx={{ mb: 1 }} />
          <Skeleton variant="text" height={40} sx={{ mb: 1 }} />
          <Skeleton variant="text" height={40} sx={{ mb: 1 }} />
        </Box>

        {/* Main Content */}
        <Box sx={{ flexGrow: 1, p: 2 }}>
          {/* Header Skeleton */}
          <Skeleton variant="rectangular" width="100%" height={60} sx={{ mb: 2 }} />
          
          {/* Page Content Skeleton */}
          <Skeleton variant="rectangular" width="100%" height={200} sx={{ mb: 2 }} />
          <Skeleton variant="text" height={40} sx={{ mb: 1 }} />
          <Skeleton variant="text" height={40} sx={{ mb: 1 }} />
          <Skeleton variant="text" height={40} sx={{ mb: 1 }} />
        </Box>
      </Box>
  )
}

export default SkeletonLoader